/* eslint-disable @typescript-eslint/naming-convention */
const MAX_SEED = 2147483647;
const DEFAULT_SEED = 1234567;

export interface IRandom {
    setSeed(seed: number): void;
    getSeed(): number;
    random(): number;
    randInt(low: number, high: number): number;
    randFloat(low: number, high: number): number;
    randomString(length?: number): string;
}

/** 确定性伪随机数实例（Park-Miller 算法） */
export class ParkMillerRandom implements IRandom {
    private __seed: number;

    constructor(initialSeed = DEFAULT_SEED) {
        this.__seed = initialSeed % MAX_SEED;
    }

    /** 设置随机种子 */
    setSeed(seed: number) {
        this.__seed = seed % MAX_SEED;
    }

    /** 获取当前内部种子状态 */
    getSeed() {
        return this.__seed;
    }

    /** 生成 [0, 1) 区间的确定性伪随机浮点数 */
    random() {
        this.__seed = (this.__seed * 16807) % MAX_SEED;
        return (this.__seed - 1) / 2147483646;
    }

    /** 生成 [low, high] 区间的确定性伪随机整数 */
    randInt(low: number, high: number) {
        return low + Math.floor(this.random() * (high - low + 1));
    }

    /** 生成 [low, high) 区间的确定性伪随机浮点数 */
    randFloat(low: number, high: number) {
        return low + this.random() * (high - low);
    }

    /** 生成指定长度的随机字符串 */
    randomString(length: number = 32) {
        return this.random()
            .toString(36)
            .substring(2, 2 + length);
    }
}
